import type { Poll } from '@tunasong/schemas'

const template = {
  type: 'poll',
  name: 'New Poll',
  pollOptions: [],
  pollType: 'one-of-many',
} satisfies Poll

export default template
